import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Observable} from 'rxjs';
import {CompanyService} from '../services/company.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyListResolver implements Resolve<any> {

  constructor(
    private cs: CompanyService
  ) { }

  resolve(): Observable<any> | Observable<never> {
    return this.cs.getCompanyList();
  }

}
